import gql from 'graphql-tag'

// Navigation
export const navigationMenusQuery = gql`
    query navigationMenus($eventId: EventID!) {
        event(id:$eventId) {
            navigationItems {
                id
                order
                text
                space {
                    id
                }
                linkedSpace {
                    id
                }
            }
            navigationMenus {
                id
                order
                text
                subMenus {
                    id
                    order
                    text
                    items {
                        id
                        order
                        text
                        space {
                            id
                        }
                        linkedSpace {
                            id
                        }
                    }
                }
            }
        }
    }
`

// Spaces
export const spacesQuery = gql`
    query getSpaces($eventId: EventID!, $first: Int) {
        event(id: $eventId) {
            spaces(first: $first) {
                edges {
                    node {
                        id
                        name
                        type
                        linkedFrom {
                            id
                            name
                            type
                        }
                    }
                }
            }
        }
    }
`
